import { ProductTypeEnum } from '__generatedTypes__/globalTypes'
import { PlatformSlug } from 'constants/consts'
import { pluralize } from 'utils/pluralize'

type ProductOptionLabelParams = {
  name: string
  duration: string
  type: ProductTypeEnum
}

export const getProductOptionLabel = ({ name, duration, type }: ProductOptionLabelParams) => {
  const isMembership = type === ProductTypeEnum.Premium || type === ProductTypeEnum.PremiumMax

  if (!isMembership) {
    return name
  }

  return `${name} (${duration} ${pluralize(Number(duration), 'day', 'days')})`
}

type MembershipProduct = {
  id: string
  type: ProductTypeEnum
  duration: string
}
const PAUSE_TOKEN_ELIGIBLE_PRODUCT_TYPES = [ProductTypeEnum.Premium, ProductTypeEnum.PremiumMax]

const INBDE_RESTRICTED_MAX_DURATION = 30

export const canDisablePauseToken = (
  platformSlug: string,
  selectedProductIds: string[],
  products?: MembershipProduct[] | null
) => {
  const isVoscePlatform = platformSlug === PlatformSlug.NDEBCrusher

  if (isVoscePlatform) {
    return false
  }

  return (products ?? []).some(({ id, type, duration }) => {
    const isSelected = selectedProductIds.includes(id)
    const isEligibleMembershipType = PAUSE_TOKEN_ELIGIBLE_PRODUCT_TYPES.includes(type)
    const isRestrictedInbdeMembership =
      platformSlug === PlatformSlug.INBDEBooster && Number(duration) <= INBDE_RESTRICTED_MAX_DURATION

    return isSelected && isEligibleMembershipType && !isRestrictedInbdeMembership
  })
}
